<template>
  <router-view />
</template>

<script>
export default { name: 'Roles' }
</script>
